/* 
 	* 指令下发组件 
 	* 描述：设置临时紧急追踪 
 	* 创建时间：2017-05-3 
 	* 创建人：baixx 
*/
<template>
    <div>
     	<form class="form-horizontal pt10px">
     		<div class="form-group">
				<label class="col-sm-3 control-label"><span class="red pr5px">*</span>追踪时长</label>
				<div class="col-sm-8">
					<input type="text" class="form-control" v-model="trackLength"/>
					<span  class="dis_block pt5px orange_t">单位秒，范围300~1800</span>
			   </div>	
			</div>
			<div class="form-group">
				<label class="col-sm-3 control-label"><span class="red pr5px">*</span>上报间隔</label>
				<div class="col-sm-8">
					<input type="text" class="form-control" v-model="reportingInterval"/>
					<span  class="dis_block pt5px orange_t">单位秒，范围30秒~追踪时长的0.5倍</span>
			   </div>	 
			</div>
			<div class="form-group">
				<label class="col-sm-3 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
			 <div class="form-group text-right pt10px" >
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div>
		</form>	
    </div>	
</template>
<script>
	export default {
		name: "InsBKTrack",
		data() {
			return {
				trackLength :'',            //追踪时长
				reportingInterval :'',      //上报间隔
				alertMsg:''
			};	
		},
		props:['from','delCmd'],
		watch:{
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		methods: {
			resetInput(){
				this.trackLength = ''
				this.reportingInterval = ''
				this.alertMsg = ''
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			nextClick(){
				let r = /^[3-9]\d{2}$|^1[0-7]\d{2}$|^1800$/.test(this.trackLength)
				if(!r){
					this.alertMsg = "追踪时长填写不正确"
					return;
				}else{
					this.alertMsg = ''
				}
				if(this.trackLength!=""){
					let len = this.trackLength * 0.5;
					if(this.reportingInterval!=''){
						if(/^\d+$/.test(this.reportingInterval)){
							if(this.reportingInterval >= 30 && this.reportingInterval <= len ){
								this.alertMsg = ''
							}else{
								this.alertMsg = "上报间隔填写不正确"
								return;
							}
						}else{
							this.alertMsg="上报间隔必须为数字"
							return;
						}
					}else{
						this.alertMsg="上报间隔不能为空"
						return;
					}
				}else{
					this.alertMsg="请先填写追踪时长"
					return;
				}
				let arr = ['SETPRM','09',this.trackLength,this.reportingInterval]
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// InsBKTrack.vue?32fe3090